import VueCookies from 'vue-cookies';

import config from '@/../config/build-config';
import analyticsUtils from '@/core/analytics/analytics-utils';

import authConstants from '@/auth/auth.constants';

const { cookieDomain, authTokenName } = config;

export default {
  state: {
    config,
    authToken: VueCookies.get(authTokenName),
    user: {},
    vendorUser: null,
    pageTitle: '',
    invalidLoginCount: 0,
  },
  mutations: {
    setAuthToken(state, authToken, expires) {
      state.authToken = authToken;
      VueCookies.set(authTokenName, authToken, expires, null, cookieDomain);
    },
    removeAuthToken(state) {
      state.authToken = null;
      VueCookies.remove(authTokenName, null, cookieDomain);
    },
    setUser(state, user) {
      state.user = user;
      analyticsUtils.identifyUser(user);
    },
    resetUser(state) {
      state.user = {};
    },
    setVendorUser(state, vendorUser) {
      state.vendorUser = vendorUser;
    },
    setPageTitle(state, pageTitle) {
      const title = pageTitle ? `${pageTitle} | iPRO` : 'iPRO';
      state.pageTitle = title;
      document.title = title;
    },
    setInvalidLoginCount(state, count) {
      state.invalidLoginCount = count;
    },
  },
  getters: {
    hasAuthToken: state => !!state.authToken,
    invalidLoginCountExceedsWarningLimit: state => state.invalidLoginCount >= authConstants.invalidLoginWarningLimit,
    umBaseUrl: state => `${state.config.endpoints.um.endpoint}/v${state.config.endpoints.um.version}`,
    vmBaseUrl: state => `${state.config.endpoints.vm.endpoint}/v${state.config.endpoints.vm.version}`,
  },
};
